import useNotifier from "@saleor/hooks/useNotifier";

export const handleGraphQLErrors = (errors: any): void => {
  const notify = useNotifier();
  const [error] = errors?.graphQLErrors;
  if (error && error?.message) {
    notify({
      status: "error",
      text: error?.message
    });
  }
};
